import type { SxProps, Theme } from '@mui/material/styles';

export const rootStyles = {
  flexGrow: 1,
  minHeight: '100vh',
  maxHeight: '100%',
  position: 'relative',
  overflow: 'hidden',
} satisfies SxProps<Theme>;

export const mainContainerStyles = {
  margin: '0 2rem 0 5rem',
} satisfies SxProps<Theme>;

export const mainContainerMobileStyles = {
  padding: '0 1rem 0 1rem',
  margin: 0,
  paddingTop: '56px', // Space for fixed MobileHeader
  width: '100%',
  maxWidth: '100%',
} satisfies SxProps<Theme>;

export const modelPortfolioRootStyles = {
  height: '100vh',
  overflow: 'hidden',
} satisfies SxProps<Theme>;
